import { ActiveReturnRebalancingType } from '@/types/ActiveReturnRebalancingType';
import getEnv from '../utils/getEnv';

export default function useDefaultActiveReturnRebalancingType(): {
  DEFAULT_ACTIVE_RETURN_REBALANCING_TYPE: ActiveReturnRebalancingType;
} {
  const { isBarclaysEnvironment } = getEnv();

  /**
   * Default rebalancing types:
   * - Uses DAILY rebalancing for Barclays environment.
   * - Uses the default rebalancing type for all other platforms.
   */
  const DEFAULT_ACTIVE_RETURN_REBALANCING_TYPE = isBarclaysEnvironment
    ? ActiveReturnRebalancingType.DAILY
    : ActiveReturnRebalancingType.NO_REBALANCING;

  return {
    DEFAULT_ACTIVE_RETURN_REBALANCING_TYPE,
  };
}
